import { render } from "./string-snapshot.vue?vue&type=template&id=67e995d2&ts=true"
import script from "./string-snapshot.vue?vue&type=script&lang=ts"
export * from "./string-snapshot.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__